[
  {
    "appName": "ExampleApp",
    "description": "Events Logger",
    "image": "//bldrs.ai/icons/LogoBWithDomain.svg",
    "action": "/widgets/event-logger.html",
    "icon": "//bldrs.ai/icons/LogoB.svg"
  }
]
